import React, { useEffect } from 'react';
import Lenis from 'lenis';
import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import SocialRail from './components/SocialRail';
import ScrollPhoto from './components/ScrollPhoto';
import Skills from './components/Skills';
import Projects from './components/Projects';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      wheelMultiplier: 0.9,
      touchMultiplier: 1.5,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Nav />
      <SocialRail />

      <div className="hero-about-wrapper" style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
        <ScrollPhoto />
        <Hero />
        <About />
      </div>

      <Skills />
      <Projects />
    </div>
  );
}

export default App;
